/* ==========================================================================
   Aori K Beauty — arrivals-bento.js
   Bento blocks with muted background video:
   - Desktop (mouse): video plays on hover/focus, pauses on leave/blur; click → link.
   - Touch: 1st tap plays the video; 2nd tap activates the link.
   - Keyboard: focus plays; Enter/Space activates the link.
   Link target: 'parent' (navigate) or 'lightbox' (linked page in an iframe modal).
   ========================================================================== */
(function () {
  'use strict';

  var lb, lbFrame;

  function buildLightbox() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'bento-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<div class="bento-lightbox__frame"><button type="button" class="bento-lightbox__close" aria-label="Cerrar">✕</button></div>';
    lbFrame = lb.querySelector('.bento-lightbox__frame');
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLightbox(); });
    lb.querySelector('.bento-lightbox__close').addEventListener('click', closeLightbox);
    document.body.appendChild(lb);
  }
  function openLightbox(href) {
    buildLightbox();
    var old = lbFrame.querySelector('iframe');
    if (old) old.remove();
    var ifr = document.createElement('iframe');
    ifr.src = href;
    ifr.setAttribute('loading', 'lazy');
    lbFrame.appendChild(ifr);
    lb.classList.add('is-open');
    document.body.classList.add('no-scroll');
  }
  function closeLightbox() {
    if (!lb) return;
    lb.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    var ifr = lbFrame.querySelector('iframe');
    if (ifr) ifr.remove();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });

  function play(cell) {
    var v = cell.querySelector('video');
    if (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); cell.classList.add('is-playing'); }
  }
  function pause(cell) {
    var v = cell.querySelector('video');
    if (v) { v.pause(); cell.classList.remove('is-playing'); }
  }
  function activate(cell) {
    var href = cell.getAttribute('data-href');
    if (!href) return;
    if (cell.getAttribute('data-target') === 'lightbox') openLightbox(href);
    else window.location.href = href;
  }

  function init(cell) {
    var hasVideo = !!cell.querySelector('video');

    cell.addEventListener('mouseenter', function () { if (matchMedia('(pointer: fine)').matches) play(cell); });
    cell.addEventListener('mouseleave', function () { if (matchMedia('(pointer: fine)').matches) { pause(cell); cell._tapped = false; } });
    cell.addEventListener('focus', function () { play(cell); });
    cell.addEventListener('blur', function () { pause(cell); cell._tapped = false; });

    cell.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(cell); }
    });

    cell.addEventListener('pointerup', function (e) {
      if (e.pointerType === 'touch') {
        if (hasVideo && !cell._tapped) { cell._tapped = true; play(cell); }
        else { activate(cell); }
      } else {
        activate(cell); // mouse / pen
      }
    });
  }

  function boot() { document.querySelectorAll('[data-bento-cell][data-href]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bento-cell][data-href]').forEach(init);
  });
})();
